<mat-sidenav-container>
  <mat-sidenav
    class="main row create_campaign"
    #sidenav
    mode="over"
    position="end"
    [opened]="cmaState.openCreateReportSheet | async"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>Create {{ reportType }}</h4>
      <div class="header-right">
        <div class="report-info" *ngIf="userTrialResponse?.isPaymentNeeded">
          <span *ngIf="showFreeTrial">
            <span class="Remaining-count">{{ userTrialResponse.remainingNumberOfFreeReports }}</span
            ><span class="total-count"> / {{ userTrialResponse.totalNumberOfFreeReports }}</span>
            Free Reports Remaining
          </span>
          <span *ngIf="!showFreeTrial">
            Trial ended. Reports cost
            <span class="Remaining-count">${{ userTrialResponse.amountPerReport }}</span> each.
          </span>
        </div>
      </div>
      <button type="button" (click)="closeSheet('reset')"><mat-icon>close</mat-icon></button>
    </div>
    <div class="row pl-4" *ngIf="!proceedReportCreation">
      <div class="col-md-12 col-12">
        <div class="redirection-message">
          <div class="redirection-dialog">
            <mat-icon class="warning-icon">warning</mat-icon>
            <p>{{ redirectionMessage }}</p>
            <!-- <Button mat-flat-button color="primary" (click)="redirect(redirectTo)">Click Here</Button> -->
            <button mat-flat-button color="primary" (click)="redirect(redirectTo)">Click Here</button>
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="cmaForm" *ngIf="proceedReportCreation">
      <div class="report-main">
        <div class="row">
          <div class="col-6 col-md-4" *ngIf="reportType == 'CMA'">
            <mat-form-field class="small-form-field">
              <mat-label>Client Type *</mat-label>
              <mat-select formControlName="clientType">
                <mat-option value="buyer">Buyer</mat-option>
                <mat-option value="seller">Seller</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-6 col-md-4" *ngIf="reportType == 'CMA'">
            <mat-form-field class="small-form-field">
              <mat-label>Client Name *</mat-label>
              <input matInput formControlName="clientName" />
              <mat-error>
                <span *ngIf="cmaForm.get('clientName')?.hasError('required')"> Name is required </span>
                <span *ngIf="cmaForm.get('clientName')?.hasError('pattern')"> Only alphabets are allowed </span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <app-property-search [initialAddress]="queryAddress"></app-property-search>
            <div class="mt-2" *ngIf="!showPropertyDetailsCard">
              <a class="advance" (click)="toggleBottomSection()">
                {{ showBottomSection ? 'Hide Advanced Search' : 'Advanced Search' }}
              </a>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
        <div class="clearfix"></div>

        <div *ngIf="showBottomSection && !showPropertyDetailsCard">
          <h6 class="pt-3">Search by Address</h6>
          <app-property-search-address></app-property-search-address>

          <div class="clearfix"></div>
        </div>
        <app-property-search-list *ngIf="!showPropertyDetailsCard"></app-property-search-list>
      </div>

      <div class="report-main ptd-0" *ngIf="showPropertyDetailsCard">
        <h5 class="pb-2">Property Details</h5>

        <app-property-details-card (propertyDetails)="propertyDetailsChange($event)"></app-property-details-card>

        <div
          class="col-6 col-md-3 d-flex align-items-center"
          *ngIf="(userType == 'agent' || userType == 'loanOfficer') && reportType == 'CMA' && companyAlias != 'opscan'"
        >
          <mat-form-field class="small-form-field flex-grow-1 mb-0">
            <mat-label *ngIf="userType == 'agent'">Select Loan Officer for Co-Branding</mat-label>
            <mat-label *ngIf="userType == 'loanOfficer'">Select Agent for Co-Branding</mat-label>
            <mat-select formControlName="selectedUser">
              <ng-container *ngIf="connectedUsers?.length != 0; else noUsers">
                <mat-option *ngFor="let user of connectedUsers" [value]="user._id">
                  {{ user.firstName }} {{ user.lastName }}
                </mat-option>
              </ng-container>
              <ng-template #noUsers>
                <mat-option>No Partner {{ userType == 'agent' ? 'Loan Officer' : 'Agent' }}</mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
          <mat-icon
            class="ms-2 icon"
            matTooltip="Easily co-brand your report—just invite a {{
              userType == 'agent' ? 'loan officer' : 'agent'
            }} under My Clients -> Partners"
            matTooltipPosition="right"
            >info_outline</mat-icon
          >
        </div>

        <div class="col-6 col-md-4 pl-0 mt-3">
          <button
            mat-flat-button
            color="primary"
            class="primary mr-2"
            (click)="createReport()"
            [disabled]="(cmaForm.invalid && reportType == 'CMA') || this.propertyDetails.livingArea == null"
          >
            Create {{ reportType }}
          </button>
        </div>
      </div>

      <div class="section-in-progress" *ngIf="isLoadingCreateReport">
        <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
        Please wait while we load
      </div>
      <div class="slidesheetcontent"></div>
    </form> </mat-sidenav
></mat-sidenav-container>
